import { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import instance from "../../services/endpoint";
import "../../styles/clicktoverify.css";
import { toast } from "react-toastify";

const EmailVerify = ({ show, handleClose }) => {
  const { emailVerifyToken } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);
  const [hasRequested, setHasRequested] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setLoading(true);
    setIsLoading(true);
    if (emailVerifyToken) {
      try {
        const response = await instance.post(
          `/api/v1/auth/verifyEmail/${emailVerifyToken}`,
          {},
          { withCredentials: true }
        );
        toast.success("Email Verified Successfully");
        setIsVerified(true);
      } catch (err) {
        setError(err.response?.data?.message || "Verification failed. Please try again.");
        toast.error(err.response?.data?.message || "Verification failed. Please try again.");
      } finally {
        setIsLoading(false);
        setLoading(false);
        setHasRequested(true);
      }
    }
  };

  const goToWebLogin = () => navigate("/login");

  // const goToMobileInfo = () => {
    // toast.info("Please open the mobile app to log in.");
    const goToMobileInfo = () => {
  const scheme = "crmrichessesolutions://login"; // match scheme in app.json
  const fallback = "https://play.google.com/store/apps/details?id=com.richesse.crm";

  // Attempt to open app
  window.location.href = scheme;

  setTimeout(() => {
    window.location.href = fallback;
  }, 2000);
};

    // handleClose();
  // };

  return (
    <>
      {!hasRequested ? (
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Body className="p-4">
            <Modal.Title className="text-center mb-4">
              <h3>Email Verification</h3>
            </Modal.Title>

            <Form>
              <Button
                variant="primary"
                className="w-100 mb-3"
                onClick={handleVerify}
                style={{
                  borderRadius: "20px",
                  background: "#d4af37",
                  border: "none",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#e5c100")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#ffd700")}
              >
                {loading ? <Spinner animation="border" className="d-block mx-auto" /> : "Verify Email"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Body className="p-4 text-center">
            {isVerified && (
              <>
                <h4 className="mb-3">Email Verified Successfully!</h4>
                <p className="mb-4">You can now log in using your preferred method:</p>
                <div className="d-grid gap-2">
                  <Button
                    variant="primary"
                    onClick={goToWebLogin}
                    style={{ borderRadius: "20px" }}
                  >
                    Login on Web
                  </Button>
                  <Button
                    variant="success"
                    onClick={goToMobileInfo}
                    style={{ borderRadius: "20px" }}
                  >
                    Login on Mobile App
                  </Button>
                </div>
              </>
            )}
            {error && <p className="email-verification-error mt-3">{error}</p>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default EmailVerify;